// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container__src-labstep-web-components-Metadata-Form-ShowEdit-Options-_euA8s"};